<template>
  <div>
    <v-data-table
      v-bind="this.$attrs"
      loading-text="Đang Tải"
      item-key="id"
      :headers="headers"
      :items="teachingPlanes"
      :loading="loading"
      no-data-text="Không có kế hoạch giảng dạy"
      :footer-props="{
        'items-per-page-text': 'Hiển thị mỗi trang',
        'items-per-page-all-text': 'Tất cả',
        'items-per-page-options': teachingPlanes.length > 100 ? [10, 20, 30] : [10, 20, -1]
      }"
      disable-sort
    >
      <template v-slot:[`item.class.title`]="{ item }">
        <router-link
          style="text-decoration: none"
          :to="'/class/' + (item.class && item.class.id)"
          v-if="$auth.policies['view-class']"
        >
          <span v-if="item.class">{{ item.class && item.class.title }}</span>
        </router-link>
        <div v-else>
          <span v-if="item.class">{{ item.class && item.class.title }}</span>
        </div>
      </template>

      <!-- Cập nhật lần cuối bởi -->
      <template v-slot:item.updatedBy="{ item }">
        <div class="table-cell-wrapper mb-1 mt-1" style="align-items: center">
          <div>
            <div>{{ item.updatedBy && item.updatedBy.name }}</div>
            <div>{{ formatDate(item.updatedAt) }}</div>
          </div>
        </div>
      </template>

      <template v-slot:[`item.teacher`]="{ item }">
        <div class="d-flex flex-row">
          <div style="width: 220px" class="mr-8">
            <CardTeacherName v-if="item.teacher" :teacher="item.teacher" link />
            <span v-else style="color: red">Chưa có giáo viên</span>
          </div>
          <div style="width: 80px" v-if="item.teacher" class="align-self-center center mr-8">
            <p class="grey--text mb-0">Ngày sinh</p>
            <div v-if="item.teacher && item.teacher.dob">{{ item.teacher.dob | ddmmyyyy }}</div>
            <div v-else-if="item.teacher.metadata && item.teacher.metadata.dob">
              {{ item.teacher.metadata.dob | ddmmyyyy }}
            </div>
          </div>
          <div v-if="item.teacher" class="align-self-center center">
            <p class="grey--text mb-0">Giới tính</p>
            <div>{{ item | _get('teacher.gender') | gender }}</div>
          </div>
        </div>
      </template>
      <template v-slot:[`item.status`]="{ item }">
        <v-chip
          small
          :style="{ color: item.status ? 'white' : '#9C9C9C', margin: 0 }"
          :color="item.status | teachingPlanStatusColor"
          label
        >
          {{ item.status | teachingPlanStatus }}
        </v-chip>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <router-link style="text-decoration: none" :to="`/teaching-plan/${item._id}`">
          <v-icon color="primary">mdi-eye</v-icon>
        </router-link>
      </template>
    </v-data-table>

    <!-- <TeachingPlanEditDialog :state="editDialog" :teachingPlanData="selectedItem" /> -->
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import moment from 'moment'
import CardTeacherName from '@/components/basic/card/CardTeacherName.vue'

const originHeaders = [
  { text: 'Khối', value: 'grade.gradeNumber', align: 'left', sortable: false },
  { text: 'Lớp', value: 'class.title', align: 'left', sortable: false },
  { text: 'Môn học', value: 'subject.title', align: 'left', sortable: false },
  { text: 'Giáo viên phụ trách', value: 'teacher', align: 'left', sortable: false },
  { text: 'Trạng thái', value: 'status', align: 'left', sortable: false },
  { text: 'Cập nhật lần cuối', value: 'updatedBy', align: 'left', sortable: false },
  { text: 'Thao tác', value: 'actions', align: 'left', sortable: false }
]

export default {
  components: {
    CardTeacherName
    // TeachingPlanEditDialog: () => import('@/modules/teachingPlan/TeachingPlanEditDialog.vue'),
  },

  data() {
    return {
      headers: originHeaders,
      confirmDialog: false,
      search: '',
      tableOptions: {},
      editDialog: false,
      selectedItem: null
    }
  },

  async created() {
    // await this.refresh()
  },

  methods: {
    ...mapActions('TeachingPlan', ['requestPageSettings', 'searchTeachingPlanList', 'removeTeachingPlan']),
    formatDate(date) {
      return moment(date).format('DD/MM/YYYY, HH:mm')
    },

    async refresh(query) {
      query = query || {}

      this.searchTeachingPlanList(query)
    },

    onEdit(item) {
      this.editDialog = !this.editDialog

      this.selectedItem = item
    },

    onConfirmTeachingPlan(item) {
      this.confirmDialog = !this.confirmDialog
      this.selectedItem = item
    },

    onRemove(item) {
      this.$dialog.confirm({
        title: 'Thông báo xác nhận',

        text: 'Bạn có chắc muốn xóa đồng phục này? Bạn không thể hoàn tác hành động.',

        okText: 'OK',

        cancelText: 'Hủy',

        done: async () => {
          this.$loading.active = true

          try {
            await this.removeTeachingPlan(item._id)

            this.$alert.deleteSuccess()
          } catch (error) {
            this.$alert.deleteError(error)
          } finally {
            this.$loading.active = false
          }
        }
      })
    }
  },

  computed: {
    ...mapState('TeachingPlan', ['teachingPlanes', 'totalItems', 'pageText', 'loading'])
  },

  watch: {}
}
</script>

<style lang="scss" scoped>
.center-icon >>> i {
  margin-left: 0px !important;
  margin-right: 0px !important;
}
.table-cell-wrapper {
  padding-top: 8px !important; /* Căn lề 8px */
  display: flex;
  align-items: flex-start; /* Căn theo top */
  justify-content: flex-start; /* Căn trái */
  height: 100%;
}
</style>
